module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-x-ae1b3d70.svg";